import { getIconClassName } from '@uifabric/styling/lib/index';
import { MailIcons } from 'mini-mail-icons';
import { MiniIcons } from 'owa-mini-icons';
import { PropertyIcons } from '../schema/PropertyIcons';
/**
 * Gets the style of the property icon passed as input
 * Do not include owa-sprites for now since it's currently targeted for consumers.
 * var spriteStyles = require('owa-sprite/dist/styles/mail_sprite.css');
 * @param propertyIcon
 */

export function getPropertyIconStyle(propertyIcon: PropertyIcons): string {
    switch (propertyIcon) {
        case PropertyIcons.GlobalMentionedMe:
            return getIconClassName(MailIcons.Accounts);
        case PropertyIcons.Attachment:
            return getIconClassName(MiniIcons.Attach);
        case PropertyIcons.ImportanceLow:
            return getIconClassName(MailIcons.Down);
        case PropertyIcons.ImportanceHigh:
            return getIconClassName(MailIcons.Important);
        case PropertyIcons.Like:
            return getIconClassName(MailIcons.Like);
        case PropertyIcons.MailListViewReplied:
            return getIconClassName(MailIcons.Reply);
        case PropertyIcons.MailListViewForwarded:
            return getIconClassName(MiniIcons.Forward);
        case PropertyIcons.MailListViewIRM:
            return getIconClassName(MailIcons.Drm);
        case PropertyIcons.MailListViewIRMReplied:
            //return spriteStyles["mail-icon-irm_replied"];
            return getIconClassName(MailIcons.Drm);
        case PropertyIcons.MailListViewIRMForwarded:
            //return spriteStyles["mail-icon-irm_forwarded"];
            return getIconClassName(MailIcons.Drm);
        case PropertyIcons.MailListViewVoiceMailItem:
            return getIconClassName(MailIcons.Memo);
        case PropertyIcons.MailListViewVoiceMailReplied:
            return getIconClassName(MailIcons.VoicemailReply);
        case PropertyIcons.MailListViewVoiceMailForwarded:
            return getIconClassName(MailIcons.VoicemailForward);
        case PropertyIcons.MailListViewVoiceMailIRM:
            //return spriteStyles["mail-icon-voicemail_irm"];
            return getIconClassName(MailIcons.Drm);
        case PropertyIcons.MailListViewFaxItem:
            return getIconClassName(MailIcons.Fax);
        case PropertyIcons.MailListViewAppointmentItem:
            return getIconClassName(MiniIcons.Event);
        case PropertyIcons.MailListViewAppointmentAccepted:
            //return spriteStyles["mail-icon-event_accepted"];
            return getIconClassName(MiniIcons.EventAccepted);
        case PropertyIcons.MailListViewAppointmentDeclined:
            //return spriteStyles["mail-icon-event_declined"];
            return getIconClassName(MiniIcons.EventDeclined);
        case PropertyIcons.MailListViewAppointmentTentative:
            //return spriteStyles["mail-icon-event_tentative"];
            return getIconClassName(MiniIcons.EventTentative);
        case PropertyIcons.MailListViewAppointmentCanceled:
            return getIconClassName(MiniIcons.RemoveEvent);
        case PropertyIcons.MailListViewContactItem:
            return getIconClassName(MailIcons.ContactCard);
        case PropertyIcons.MailListViewTaskItem:
            return getIconClassName(MiniIcons.CheckboxComposite);
        case PropertyIcons.MailListViewTaskReocurItem:
            return getIconClassName(MailIcons.RecurringTask);
        case PropertyIcons.MailListViewJournalItem:
            return getIconClassName(MailIcons.DietPlanNotebook);
        case PropertyIcons.MailListViewPostItem:
            return getIconClassName(MailIcons.NotePinned);
        case PropertyIcons.MailListViewNoteItem:
            return getIconClassName(MailIcons.QuickNote);
        case PropertyIcons.MailListViewDelivery:
            // Bug 1752 - culture specific
            return getIconClassName(MailIcons.ReceiptForward);
        case PropertyIcons.MailListViewNonDelivery:
            // Bug 1752 - culture specific
            return getIconClassName(MailIcons.ReceiptReply);
        case PropertyIcons.MailListViewApprovalRequest:
            // add sprite response_request.png
            return getIconClassName(MailIcons.ReceiptReply);
        case PropertyIcons.MailListViewResponseApprove:
            // add sprite response_approve.png
            return getIconClassName(MailIcons.ReceiptReply);
        case PropertyIcons.MailListViewResponseReject:
            // add sprite response_reject.png
            return getIconClassName(MailIcons.ReceiptReply);
        case PropertyIcons.MailListViewOutOfOffice:
            // Bug 1752 - culture specific
            return getIconClassName(MailIcons.OutOfOffice);
        case PropertyIcons.MailListViewReadReport:
            return getIconClassName(MailIcons.ReceiptCheck);
        case PropertyIcons.MailListViewReminderMessage:
            return getIconClassName(MailIcons.Ringer);
        default:
            throw new Error('No CSS class icon for the given property icon');
    }
}
